import { api, API_URL } from '@/common/apiService'
import {showSnackbar} from '@/common/utils'
import JwtService from '@/common/jwtService'
import {requestPermission} from "@/common/pushService"
import {
    AUTH_LOGIN, AUTH_ERROR,
    AUTH_SUCCESS, AUTH_LOGOUT,
    REFRESH_TOKEN
} from '../actions/auth';
import { USER_REQUEST, PROFILE_DELETE } from '../actions/user';
import router from '@/routes/router'
import {GET_COMMON_DATA} from "../actions/common";
import { Store } from 'vuex';
import axios from 'axios'

const state = {
    token: JwtService.getToken() || '',
    status: '',
    hasLoadedOnce: false,
    lastLogin: 0
};

const getters = {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
};

const actions = {
    [AUTH_LOGIN]: ({commit, dispatch, rootState}, {username, password}) => {
        commit(AUTH_LOGIN);
        let body = JSON.stringify({username, password});
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
        return axios.post(`${API_URL}api/auth/jwt/create/`, body, { 
            headers:{
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    }).then((resp) => {
        dispatch(AUTH_SUCCESS, resp.data);
        dispatch(USER_REQUEST).then(() => {
            dispatch(GET_COMMON_DATA);
            // Add the public key generated from the console here.
            requestPermission()
            router.push('/marshal')
        })
    }).catch(error => {
        if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            if (error.response.status >= 400 && error.response.status < 500) {
              dispatch(AUTH_LOGOUT)
              showSnackbar({
                message: 'Incorrect password, Please try again',
                url:'',
                color:'red', 
                timeout: 10000
              })
            }
        } else if (error.request) {
            console.log(error.request);
            commit(AUTH_ERROR)
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
        }
        console.log(error.config);
    })
    },

    [REFRESH_TOKEN]: async ({commit, dispatch}) => {
        const token = JwtService.getToken();
        const body = JSON.stringify({"token": token});
        return api.post('/api-token-refresh/', body).then((resp) => {
            dispatch(AUTH_SUCCESS, resp.data)
        })
            .catch(error => {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
                dispatch(AUTH_LOGOUT)
            })
    },

    [AUTH_SUCCESS]: ({commit, dispatch}, {token}) => {
        JwtService.saveToken(token);
        commit(AUTH_SUCCESS, token);
        
    },
    [AUTH_LOGOUT]: ({commit, dispatch, rootState}) => {
        JwtService.removeToken();
        commit(AUTH_LOGOUT);
        commit(PROFILE_DELETE)
        router.push("/")
    },
    [AUTH_ERROR]: ({commit, dispatch}) => {
        commit(AUTH_ERROR)
    }
};

const mutations = {
    [AUTH_LOGIN]: (state) => {
        state.status = 'loading';
    },
    [AUTH_SUCCESS]: (state, token) => {
        state.status = 'success';
        state.token = token;
        state.hasLoadedOnce = true;
        state.lastLogin = Date.now();
    },
    [AUTH_ERROR]: (state) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
    },
    [AUTH_LOGOUT]: (state) => {
        state.token = '';
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
